export interface Kit {
  id: string;
  name: string;
  idealFor: string;
  badge?: string;
  includes: string[];
  monitoring: string;
}

export const KITS: Kit[] = [
  {
    id: 'esencial',
    name: 'Esencial',
    idealFor: 'Espacios reducidos',
    includes: [
      'Central Alarma Inteligente',
      '1 Sensor de Movimiento',
      '1 Sensor de Apertura',
      '1 Control Remoto (Llavero)',
      'App Móvil Básica',
    ],
    monitoring:
      'Monitoreo 24/7 con central receptora de alarmas, notificación de eventos y verificación ante activaciones.',
  },
  {
    id: 'plus',
    name: 'Plus',
    idealFor: 'Hogares familiares',
    badge: 'Preferido',
    includes: [
      'Central Alarma Avanzada',
      '3 Sensores de Movimiento (Pet Immune)',
      '3 Sensores de Apertura',
      '1 Cámara Interior Wi-Fi',
      '2 Controles Remotos',
      'Sirena Interior Potente',
      'App Móvil Full',
    ],
    monitoring:
      'Monitoreo 24/7 con verificación por video, notificaciones push en tiempo real y despacho de móvil ante emergencias.',
  },
  {
    id: 'premium',
    name: 'Premium',
    idealFor: 'Propiedades grandes',
    includes: [
      'Central Híbrida Profesional',
      '5 Sensores de Movimiento (Int/Ext)',
      'Perimetral Infrarrojo',
      '2 Cámaras (1 Int / 1 Ext)',
      'Teclado Touch',
      'Sirena Exterior con Flash',
      'Integración Smart Home',
    ],
    monitoring:
      'Monitoreo 24/7 perimetral con verificación por video, coordinación con fuerzas de seguridad y despacho prioritario de móvil.',
  },
  {
    id: 'comercio',
    name: 'Comercio',
    idealFor: 'Locales y Oficinas',
    includes: [
      'Central Comercial Grado 3',
      'Sensores de Rotura de Cristal',
      'Botón de Pánico Silencioso',
      'Cámara sobre Caja Registradora',
      'Control de Acceso de Empleados',
      'Reportes de Apertura/Cierre',
    ],
    monitoring:
      'Monitoreo 24/7 comercial con reportes de apertura y cierre, alarma silenciosa con despacho inmediato y auditoría de accesos.',
  },
];
